/** TanStack Query keys — one factory so invalidation is predictable. */
export const qk = {
  towns: ['towns'] as const,
  categories: ['categories'] as const,
  subcategories: (slug: string, town: string | null) => ['subcategories', slug, town] as const,
  home: (town: string | null) => ['home', town] as const,
  sectionProducts: (code: string, town: string | null, sort: string) =>
    ['home', 'section', code, town, sort] as const,
  products: (params: Record<string, unknown>) => ['products', params] as const,
  product: (id: number) => ['product', id] as const,
  shops: (params: Record<string, unknown>) => ['shops', params] as const,
  shop: (slug: string) => ['shop', slug] as const,
  shopProducts: (slug: string, params: Record<string, unknown>) =>
    ['shop', slug, 'products', params] as const,
  search: (params: Record<string, unknown>) => ['search', params] as const,
  cartValidate: (lines: string) => ['cart-validate', lines] as const,
  suggest: (q: string, town: string | null) => ['suggest', q, town] as const,
  collections: (town: string | null, home: boolean) => ['collections', town, home] as const,
  collection: (slug: string, town: string | null) => ['collection', slug, town] as const,
  collectionProducts: (slug: string, params: Record<string, unknown>) =>
    ['collection', slug, 'products', params] as const,
  related: (id: number) => ['product', id, 'related'] as const,
  forYou: (ids: string, town: string | null) => ['for-you', ids, town] as const,
}
